import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsDisabledPromotion, selectIsServicesEnabled } from '../../../../selectors/publishTerms';
import { setIsServicesEnabled } from '../../../../actions/publishTerms';

import { ServicesLayoutToggle } from './ServicesLayoutToggle';
import { useToggleLabel } from './hooks';

export const ServicesLayoutToggleContainer = () => {
  const dispatch = useDispatch();
  const isServicesEnabled = useSelector(selectIsServicesEnabled);
  const isPromotionDisabled = useSelector(selectIsDisabledPromotion);
  const { showLabel } = useToggleLabel();

  const isToggleChecked = isPromotionDisabled ? false : isServicesEnabled;

  const handleToggleChange = React.useCallback(
    (value: boolean) => {
      dispatch(setIsServicesEnabled(value));
    },
    [dispatch],
  );

  return (
    <ServicesLayoutToggle
      checked={isToggleChecked}
      disabled={isPromotionDisabled}
      showLabel={showLabel}
      onChange={handleToggleChange}
    />
  );
};
